export const memoizePromise = (fn) => {
  let cache = null;
  return async function memoized(...args) {
    if (cache) {
      return cache;
    }

    const result = await fn(...args);
    cache = result;
    return result;
  };
};
